import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import api from '@/axios';
import { UPDATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_COMMENT_KEY } from '@/keys';
import type { CorrectionRequest } from '@/types/core/purchase-order/correction-request';

type UpdateProductionDeclarationCorrectionRequestCommentVariables = {
  comment: string;
  commodityOriginId: string;
  correctionRequestId: string;
  materialId: string;
  productionDeclarationId: string;
};

async function updateProductionDeclarationCorrectionRequestComment({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  correctionRequestId,
  comment,
}: UpdateProductionDeclarationCorrectionRequestCommentVariables): Promise<CorrectionRequest> {
  const response = await api.patch<CorrectionRequest>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/correction-requests/${correctionRequestId}/comment`,
    {
      comment,
    },
  );

  return response.data;
}

export function useUpdateProductionDeclarationCorrectionRequestComment(): UseMutationResult<
  CorrectionRequest,
  Error,
  UpdateProductionDeclarationCorrectionRequestCommentVariables
> {
  return useMutation({
    mutationKey: UPDATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_COMMENT_KEY,
    mutationFn: updateProductionDeclarationCorrectionRequestComment,
  });
}
